<template>
    <div>
        <a-card title="服务调用链路">
          <v-gobackbutton slot="extra">返回</v-gobackbutton>
          <a-spin :spinning="tloading"></a-spin>

          <p>
              <label class="stitle" for="">日志查询范围:</label>
              <a-range-picker ref="cTimeRange" 
                :show-time="{
                            hideDisabledOptions: true,
                            format:'HH:mm'
                        }" :format="dateFormat"
                v-model="timeRange"
                @change="onChange" />
          </p>

          <p>
              <label class="stitle" for="">链路编号:</label>
              <a-input :style="{color:colorName,width:'350px',marginLeft:'28px'}"  placeholder="输入链路编号" @change="updateRoute('')" v-model="traceid" />

              <a-button type="primary" style="margin-left:20px;" @click="handleSearch">查询</a-button>
          </p>

          

          <p>
              <label class="stitle" for="">链路开始时间:</label>
              <span>{{traceStartT}}</span>
          </p>

          <p>
              <label class="stitle" for="">链路结束时间:</label>
              <span>{{traceEndT}}</span>
          </p>

           <p>
              <label class="stitle" for="">链路总耗时:</label>
              <span>{{traceHandTime + 'ms'}}</span>
          </p>

          <p>
              <label class="stitle" for="">原始日志:</label>
              <a-button type="link" @click="handleLogShow">查看</a-button>
              <a-modal v-model="modalVisible" title="原始日志" @ok="handleOk">
                    <json-viewer
                        :value="origintraceData"
                        :expand-depth=5
                        copyable
                        boxed
                        sort></json-viewer>
                </a-modal>
          </p>
          <timeline ref="relationTimeline" @colorChange="handleColorChange"></timeline>
        </a-card>

    </div>
</template>

<script>
import timeline from './timeline'
import JsonViewer from "vue-json-viewer"
import moment from 'moment';

export default {
    data(){
        return {
            dateFormat:"YYYY-MM-DD HH:mm",
            timeRange:undefined,
            traceid:'',
            starttime:'',
            endtime:'',
            traceData:[],
            origintraceData:[],
            traceStartT:'',
            traceEndT:'',
            traceHandTime:'',
            modalVisible:false,
            colorName:'',
            tloading:false,
        }
    },
    methods:{
        loadData(){
            this.getDefaultRange()
            this.getTraceData();
        },
        onChange(v,t){
            this.$emit("timeChange",{
                startDate:t[0],
                endDate:t[1]
            },false)
        },
        handleSearch(){
            this.traceid = this.traceid.trim()
            this.updateRoute(this.timeRange)
        },
        updateRoute(t){
            if(!t){
                t = [];
                t[0] = this.starttime;
                t[1] =  this.endtime;
            }
            this.$router.push({
                query: {
                    traceid:this.traceid,
                    starttime:new Date(t[0]).getTime(),
                    endtime:new Date(t[1]).getTime(),
                }
            });
        },
        getDefaultRange(){
            if(!this.starttime){
                this.starttime = new Date().getTime() - 10 * 60 * 1000
            }
            if(!this.endtime){
                this.endtime = new Date().getTime()
            }
            let sTime = (new Date(this.starttime)).Format("yyyy-MM-dd hh:mm");
            let eTime = (new Date(this.endtime)).Format("yyyy-MM-dd hh:mm");
            this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]
        },
 
        handleColorChange(colorName){
            this.colorName = colorName
        },
        getTraceData(){
            let that = this;

            if(!that.traceid){
                // that.message.info('请输入调用链路')
                return
            }
            //开始时间和结束时间分别扩展5分钟，防止搜索链路不全
            that.tloading = true;
            let queryStr = "* | select * from log where traceid = '" + that.traceid + "' order by starttime asc";
            let params = {
                projectname:that.G.getServiceMonitorName(),
                logstorename:'service-monitor',
                starttime:that.starttime / 1000,
                endtime:that.endtime / 1000,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:true,
                timeout:10000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.traceData = res.data.data.list;
                    let tempStr = JSON.stringify(res.data.data.list);
                    that.origintraceData = JSON.parse(tempStr);
                    if(that.traceData.length > 0){
                        that.$refs.relationTimeline.handleTimeData(that.traceData,that.traceid);
                        let firstTarget = that.traceData[0];
                        that.traceStartT = firstTarget.starttime;
                        that.traceEndT = firstTarget.endtime;
                        that.traceHandTime = firstTarget.handtime
                    }
                    else{
                        that.message.error('查无数据')
                    }
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });

        },
        handleOk(){
            this.modalVisible = false;
        },
        handleLogShow(){
            this.modalVisible = true;
        },
        
    },
    mounted(){
        let query = this.$route.query;
        if(query.traceid && query.starttime && query.endtime){
            this.traceid = query.traceid;
            this.starttime = parseInt(query.starttime);
            this.endtime = parseInt(query.endtime);
        }
        this.loadData()
    },
    destroyed(){

    },
    components:{
        timeline,
        JsonViewer
    }
};
</script>

<style lang="less" scoped>
.stitle{
    font-weight: bold;
    margin-right: 10px;
}
</style>
